<template>
  <div id="app">
    <notification-container/>

    <router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
import NotificationContainer from '@/components/notifications/NotificationContainer.vue'
// import firebaseSrv from '@/services/firebaseSrv.js'
export default {
  name: 'app',
  components: {
    NotificationContainer
  } /*,
  mounted() {
    firebaseSrv.auth.onAuthStateChanged(() => {
      this.$store.dispatch('auth/authStore')
    })
  }*/
}
</script>
<style lang="scss">
#nprogress .bar,
#nprogress .spinner {
  z-index: 1250 !important;
}
.breadcrumb {
  /* background-color: transparent !important; */
  border-radius: 0 !important;
}
</style>
